import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.bgFirstFixedAnimation = function bgFirstFixedAnimation() {
  const bgEl = document.querySelector('[data-first-parallax-bg]');
  const section = document.querySelector('[data-first-parallax-bg-sec]');
  const bodyBg = document.querySelector('.body-bg');

  console.log(section);
  

  if (!bgEl || !section) return;

  const hideThreshold = window.innerHeight * 0.18;

  ScrollTrigger.create({
    trigger: section,
    start: 'top bottom',
    end: 'bottom top',
    onUpdate: () => {
      const rect = section.getBoundingClientRect();
      
      if (rect.bottom < hideThreshold) {
        bgEl.classList.add('is-hidden');
        section.classList.add('is-hidden-gradient');
        bodyBg.classList.remove('is-worked-first-fixed-bg');
        pauseFirstGradientAnimation();
      } else {
        bgEl.classList.remove('is-hidden');
        section.classList.remove('is-hidden-gradient');

        if (!bodyBg.classList.contains('is-worked-first-fixed-bg')) {
          bodyBg.classList.add('is-worked-first-fixed-bg');
          resumeFirstGradientAnimation();
        }
      }
    },
  });
};

bgFirstFixedAnimation()

